import { useGetters } from '@/utils/mapStore';

//參數對應文字表
const mapValue = {
  all: { label: '全部', value: 'all' },
  on_site: { label: '現場', value: 'on_site' },
  phone: { label: '電話', value: 'phone' },
  foodpanda: { label: '熊貓', value: 'foodpanda' },
  line: { label: 'Line@', value: 'line' },
  uber_eat: { label: 'Uber Eats', value: 'uber_eat' },
  app: { label: 'App', value: 'app' },
  juton: { label: '揪團', value: 'juton' },
  pick_up: { label: '自取', value: 'pick_up' },
  inside: { label: '內用', value: 'inside' },
  delivery: { label: '外送', value: 'delivery' },
  prudent: { label: '精打細算', value: 'prudent', color: '#e96300' },
  healthy: { label: '健康意識', value: 'healthy', color: '#f2b400' },
  green: { label: '環保意識', value: 'green', color: '#127d9b' },
  novel: { label: '新奇時尚', value: 'novel', color: '#d96969' },
  enjoy: { label: '休閒享樂', value: 'enjoy', color: '#5f51a9' },
  date_type: ['當班', '當日', '當週', '當月', '當季', '自訂日期'],
  mobile_carrier: { label: '手機條碼', value: 'mobile_carrier' },
  citizen_digital_certificate: { label: '自然人憑證', value: 'citizen_digital_certificate' },
  love_code: { label: '捐贈碼', value: 'love_code' },
  card_carrier: { label: '卡片載具', value: 'card_carrier' },
  member_carrier: { label: '會員載具', value: 'member_carrier' },
  no_carrier: { label: '無', value: 'no_carrier' },
  i_pass: { label: '一卡通', value: 'i_pass' },
  i_pass_pay: { label: 'iPASS MONEY', value: 'i_pass_pay' },
  easy_card: { label: '悠遊卡', value: 'easy_card' },
  voucher: { label: '商品券', value: 'voucher' },
  coupon: { label: '優惠券', value: 'coupon' },
};

const mapOrderStatus = {
  1: { label: '新訂單', value: 1 },
  2: { label: '取消', value: 2 },
  3: { label: '終止', value: 3 },
  10: { label: '已結帳', value: 10 },
  15: { label: '掛單', value: 15 },
  16: { label: '待沖銷', value: 16 },
  18: { label: '作廢', value: 18 },
};

const mapInvoiceStatus = {
  0: { label: '未開立', value: 0 },
  1: { label: '已開立', value: 1 },
  2: { label: '已作廢', value: 2 },
  3: { label: '不需開立', value: 3 },
};

//點餐order-info按鈕
const getOrderButton = () => {
  return {
    sourceBtns: [
      { label: '現場', width: 50, value: 'on_site' },
      { label: '電話', width: 50, value: 'phone' },
      { label: '熊貓', width: 50, value: 'foodpanda' },
      { label: 'Line@', width: 50, value: 'line' },
      { label: 'Uber Eats', width: 50, value: 'uber_eat' },
    ],
    takeAwayBtns: [
      { label: '自取', width: 50, value: 'pick_up' },
      { label: '內用', width: 50, value: 'inside' },
      { label: '外送', width: 50, value: 'delivery' },
    ],
  };
};
//掛單按鈕
const getHangSourceButtons = () => {
  return [
    { label: '全部', value: 'all' },
    { label: '現場', value: 'on_site' },
    { label: '電話', value: 'phone' },
    { label: 'App', value: 'app' },
    { label: '揪團', value: 'juton' },
    { label: '熊貓', value: 'foodpanda' },
    { label: 'Uber Eats', value: 'uber_eat' },
  ];
};
//內部訂單按鈕
const getIncomingSourceButtons = () => {
  return [
    { label: '全部', value: 'all' },
    { label: 'App', value: 'app' },
    { label: '揪團', value: 'juton' },
  ];
};
//條件搜尋時間按鈕
const getDateRangeButton = () => {
  return [
    { label: '當班', value: 1 },
    { label: '當日', value: 2 },
    { label: '當週', value: 3 },
    { label: '當月', value: 4 },
    { label: '當季', value: 5 },
  ];
};
//單據選項
const getAttestingButton = () => {
  return [
    { label: '發票號碼', value: 'invoice_no' },
    { label: '訂單序號', value: 'serial_no' },
  ];
};

//雜支項目選項
const getCostList = () => {
  return {
    category: [
      { label: '原物料', value: 'commodity_cost' },
      { label: '固定支出', value: 'fixed_cost' },
      { label: '人事費', value: 'staff_cost' },
      { label: '行政費', value: 'supplies_cost' },
      { label: '維修費', value: 'maintain_cost' },
    ],
    item: [
      { category: 'commodity_cost', name: '養樂多', value: 'yakult', amount: 0 },
      { category: 'commodity_cost', name: '統一布丁', value: 'pudding', amount: 0 },
      { category: 'commodity_cost', name: '台糖二砂糖', value: 'sugar', amount: 0 },
      { category: 'commodity_cost', name: '精鹽', value: 'Salt', amount: 0 },
      { category: 'commodity_cost', name: '冰塊', value: 'ice', amount: 0 },
      { category: 'commodity_cost', name: '其他', value: 'commodity_other', amount: 0 },
      { category: 'fixed_cost', name: '房租', value: 'rent', amount: 0 },
      { category: 'fixed_cost', name: '電話費', value: 'phone', amount: 0 },
      { category: 'fixed_cost', name: '網路費', value: 'internet', amount: 0 },
      { category: 'fixed_cost', name: '電費', value: 'electricity', amount: 0 },
      { category: 'fixed_cost', name: '水費', value: 'water', amount: 0 },
      { category: 'fixed_cost', name: '瓦斯費', value: 'gas', amount: 0 },
      { category: 'fixed_cost', name: '有線電視費', value: 'cable', amount: 0 },
      { category: 'fixed_cost', name: '外送車油資', value: 'delivery_fuel', amount: 0 },
      { category: 'fixed_cost', name: '清潔費', value: 'clean', amount: 0 },
      { category: 'fixed_cost', name: '保險費', value: 'insurance', amount: 0 },
      { category: 'fixed_cost', name: '牌照/燃料稅', value: 'fuel_tax', amount: 0 },
      { category: 'fixed_cost', name: '營業稅', value: 'business_tax', amount: 0 },
      { category: 'fixed_cost', name: '員工餐費', value: 'meals', amount: 0 },
      { category: 'fixed_cost', name: '罰緩', value: 'fine', amount: 0 },
      { category: 'staff_cost', name: '薪資', value: 'salary', amount: 0 },
      { category: 'staff_cost', name: '勞健保費', value: 'labor_health_insurance', amount: 0 },
      { category: 'staff_cost', name: '獎金', value: 'bonus', amount: 0 },
      { category: 'supplies_cost', name: '文具用品', value: 'stationery', amount: 0 },
      { category: 'supplies_cost', name: '五金用品', value: 'hardware', amount: 0 },
      { category: 'supplies_cost', name: '生活用品', value: 'necessaries', amount: 0 },
      { category: 'supplies_cost', name: '其他', value: 'supplies_other', amount: 0 },
      { category: 'maintain_cost', name: '水電相關', value: 'plumbing_electricity', amount: 0 },
      { category: 'maintain_cost', name: 'POS設備相關', value: 'pos_equipment', amount: 0 },
      { category: 'maintain_cost', name: '冰箱/展示櫃', value: 'refrigerator', amount: 0 },
      { category: 'maintain_cost', name: '製冰機', value: 'ice_maker', amount: 0 },
      { category: 'maintain_cost', name: '廚下型開水機', value: 'water_dispenser', amount: 0 },
      { category: 'maintain_cost', name: '泡茶機', value: 'tea_maker', amount: 0 },
      { category: 'maintain_cost', name: '蒸氣加熱機', value: 'steam_heater', amount: 0 },
      { category: 'maintain_cost', name: '檸檬榨汁機', value: 'lemon_juicer', amount: 0 },
      { category: 'maintain_cost', name: '冰沙機', value: 'smoothie_maker', amount: 0 },
      { category: 'maintain_cost', name: '果糖/液糖機', value: 'fructose_machine', amount: 0 },
      { category: 'maintain_cost', name: '封口機', value: 'sealing_machine', amount: 0 },
      { category: 'maintain_cost', name: '電視', value: 'tv', amount: 0 },
      { category: 'maintain_cost', name: '監視器', value: 'monitor', amount: 0 },
      { category: 'maintain_cost', name: '冷氣', value: 'air_conditioner', amount: 0 },
      { category: 'maintain_cost', name: '外送車', value: 'delivery_car', amount: 0 },
      { category: 'maintain_cost', name: '鐵捲門', value: 'rolling_door', amount: 0 },
      { category: 'maintain_cost', name: '其他', value: 'maintain_other', amount: 0 },
    ],
  };
};

//發票相關按鈕
const getInvoiceButtons = () => {
  return [
    { label: '手機條碼', scanType: 4, click: 'handleDevice', checkDisable: 'deviceDisable' },
    { label: '自然人憑證/ 捐贈碼', scanType: 5, click: 'handleDevice', checkDisable: 'deviceDisable' },
    { label: '卡片載具', click: 'handleCardDevice', checkDisable: 'cardDisable' },
    { label: '統編', click: 'handleTax', checkDisable: 'taxDisable' },
  ];
};
//支付方式按鈕
const getPayButtons = () => {
  const getSource = useGetters('order', ['getSource']);
  return {
    dayungs_payment: {
      label: '大苑子支付',
      click: 'handleDayungs',
      checkDisable: 'dayungsDisable',
      area: '1/1/2/2',
      color: 'blue',
    },
    want_card: {
      label: '旺卡',
      payment_type: 'want_card',
      click: 'handleDayungsCard',
      checkDisable: 'cardDisable',
      area: '2/1/3/2',
      color: 'white',
    },
    cash_card: {
      label: '現金卡',
      payment_type: 'cash_card',
      click: 'handleDayungsCard',
      checkDisable: 'cardDisable',
      area: '3/1/4/2',
      color: 'white',
    },
    want_card_point: {
      label: '黃金點數',
      payment_type: 'want_card_point',
      click: 'handlePoint',
      checkDisable: 'cardDisable',
      area: '4/1/5/2',
      color: 'white',
    },
    cash: {
      label: '現金',
      payment_type: 'cash',
      click: 'handleCash',
      checkDisable: 'cashDisable',
      area: '1/2/2/3',
      color: 'blue',
    },
    card_payment: {
      label: '卡片支付',
      openDialog: 'card_payment',
      click: 'handleOpenPay',
      checkDisable: 'cardPayDisable',
      area: '1/3/2/4',
      color: 'blue',
    },
    third_party_pay: {
      label: '第三方支付',
      payment_type: 'third_party_pay',
      click: 'handlePay',
      checkDisable: 'payDisable',
      area: '1/4/2/5',
      color: 'blue',
    },
    other_payment: {
      label: '其他支付',
      openDialog: 'other_payment',
      click: 'handleOpenPay',
      checkDisable: 'otherPayDisable',
      area: '1/5/2/6',
      color: 'blue',
    },
    delivery_collection: {
      label: `${
        getSource.value === 'foodpanda' || getSource.value === 'uber_eat' ? mapValue[getSource.value].label : '外部平台'
      }支付`,
      payment_type: 'delivery_collection',
      click: 'handlePay',
      checkDisable: 'payDisable',
      area: '1/6/2/7',
      color: 'blue',
    },
  };
};

const getPaymentType = (type, source) => {
  const data = {
    member_card: {
      label: '會員卡',
      type: 0,
      payment_type: 'member_card',
    },
    cash: {
      label: '現金',
      type: 1,
      payment_type: 'cash',
      withCash: true,
    },
    credit_card: {
      label: '信用卡',
      type: 2,
      payment_type: 'credit_card',
    },
    easy_card: {
      label: '悠遊卡',
      type: 3,
      payment_type: 'easy_card',
    },
    i_pass: {
      label: '一卡通',
      type: 4,
      payment_type: 'i_pass',
    },
    gift_certificate: {
      label: '禮券',
      type: 5,
      payment_type: 'gift_certificate',
      withCash: true,
    },
    third_party_pay: {
      label: '第三方支付',
      type: 10,
      payment_type: 'third_party_pay',
    },
    jeko: {
      label: '街口',
      type: 11,
      payment_type: 'jeko',
    },
    line_pay: {
      label: 'line_pay',
      type: 12,
      payment_type: 'line_pay',
    },
    ALI_PAY: {
      label: '支付寶',
      type: 13,
      payment_type: 'ali_pay',
    },
    taiwan_pay: {
      label: '台灣pay',
      type: 14,
      payment_type: 'taiwan_pay',
    },
    uupay: {
      label: '悠遊付',
      type: 15,
      payment_type: 'uupay',
    },
    want_card: {
      label: '旺卡',
      type: 30,
      payment_type: 'want_card',
      withCash: true,
    },
    want_card_point: {
      label: '黃金點數',
      type: 31,
      payment_type: 'want_card_point',
      withCash: true,
    },
    cash_card: {
      label: '現金卡',
      type: 32,
      payment_type: 'cash_card',
      withCash: true,
    },
    park_employee_card: {
      label: '園區員工卡',
      type: 41,
      payment_type: 'park_employee_card',
      withCash: true,
    },
    panda_go: {
      label: 'PandaGo代收',
      type: 44,
      payment_type: 'panda_go',
      withCash: true,
    },
    delivery_collection: {
      label: `${source === 'foodpanda' || source === 'uber_eat' ? mapValue[source]?.label : '外部平台'}支付`,
      type: 42,
      payment_type: 'delivery_collection',
    },
  };
  return data[type];
};

export {
  mapValue,
  mapOrderStatus,
  mapInvoiceStatus,
  getOrderButton,
  getHangSourceButtons,
  getIncomingSourceButtons,
  getDateRangeButton,
  getAttestingButton,
  getCostList,
  getInvoiceButtons,
  getPayButtons,
  getPaymentType,
};
